<template>
  <div class="state q-pa-lg">
    <pre>
      {{ jsonFilter(store.state) }}
    </pre>
  </div>
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator';

import store from '@/store';
import { jsonFilter } from '@odin/utils';

export default class StatePage extends Vue {
  store = store;
  jsonFilter = jsonFilter;

}
</script>

<style lang="scss" scoped>
.state {
  pre {
    text-align: left;
  }
}
</style>
